const DEFAULT_PUBLIC_APP_URL = import.meta.env.DEV ? 'http://localhost:8080' : 'https://viratempo.app';

export function getPublicCompanyUrl(slug: string) {
  const baseUrl = String(import.meta.env.VITE_PUBLIC_APP_URL || DEFAULT_PUBLIC_APP_URL).replace(/\/+$/, '');
  return `${baseUrl}/${encodeURIComponent(slug.trim())}`;
}
